import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Eye, EyeOff, Loader2, Lock, LogIn, Mail, ShieldCheck } from "lucide-react";
import { loginUser } from "../../redux/userSlice";
import { notify } from "../../utils/toastAlert";
import AuthShell from "./AuthShell";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.user);
  const [form, setForm] = useState({ email: "", senha: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    document.body.classList.remove("bg-primary", "d-flex", "justify-content-center", "align-items-center", "min-vh-100", "p-5");
    document.body.classList.add("auth-body");
    return () => document.body.classList.remove("auth-body");
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    if (localError) setLocalError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form.email || !form.senha) {
      setLocalError("Por favor, preencha todos os campos.");
      return;
    }

    const result = await dispatch(loginUser(form));
    if (loginUser.fulfilled.match(result)) {
      await notify("Sessao iniciada com sucesso.", "success");
      navigate(result.payload?.user?.nivel === "caixa" ? "/comercial/documentos" : "/dashboard/main", { replace: true });
      return;
    }

    await notify(result.payload || error || "Nao foi possivel iniciar sessao.", "error");
  };

  const displayError = localError || error;

  return (
    <AuthShell
      size="sm"
      eyebrow="Facturize Hotelaria"
      title="Entrar no sistema"
      subtitle="Acesso para administrador e caixa."
      footer={<p>Ainda nao tem empresa? <Link to="/register">Criar conta</Link></p>}
    >
      <div className="auth-card-header">
        <span>Entrar</span>
        <h2>Iniciar sessão</h2>
      </div>

      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        {displayError && <div className="auth-alert auth-alert-danger" role="alert">{displayError}</div>}

        <div className="auth-field">
          <label htmlFor="email">Email</label>
          <div className={`auth-input-wrap ${displayError ? "has-error" : ""}`}>
            <Mail size={18} className="auth-input-icon" />
            <input type="email" id="email" name="email" value={form.email} onChange={handleChange} required placeholder="email@empresa.com" autoComplete="email" disabled={loading} />
          </div>
        </div>

        <div className="auth-field">
          <label htmlFor="senha">Senha</label>
          <div className="auth-input-wrap">
            <Lock size={18} className="auth-input-icon" />
            <input type={showPassword ? "text" : "password"} id="senha" name="senha" value={form.senha} onChange={handleChange} required placeholder="A sua senha" autoComplete="current-password" disabled={loading} />
            <button className="auth-icon-button" type="button" onClick={() => setShowPassword((current) => !current)} aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"} tabIndex={-1}>
              {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
            </button>
          </div>
        </div>

        <button className="auth-primary-button" type="submit" disabled={loading}>
          {loading ? <><Loader2 size={18} className="animate-spin" /><span>A entrar...</span></> : <><LogIn size={18} /><span>Entrar</span></>}
        </button>
        <p className="text-center mt-3"><Link to="/forgot-password">Esqueceu a senha?</Link></p>
      </form>
    </AuthShell>
  );
};

export default Login;
